import Box from "@material-ui/core/Box";
import React from "react";

export default function Spacing(): JSX.Element {
  return <Box py={3} />;
}
